import { Radio as MaterialUiRadioButton } from '@mui/material';
import { FunctionComponent, type JSX } from 'react';

import { useFieldId } from '@payaca/hooks/useFieldId';

import './RadioButton.sass';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  className?: string;
  isDisabled?: boolean;
  isSelected: boolean;
  onClick: () => void;
  id?: string;
  size?: any;
  name?: string;
};

const RadioButton: FunctionComponent<Props> = ({
  className,
  isDisabled = false,
  isSelected,
  onClick,
  id,
  size = 'medium',
  name,
}: Props): JSX.Element => {
  const fieldId = useFieldId(name || 'radio-button');
  const uniqueId = id || fieldId;

  return (
    <div className={'radio-button' + (className ? ' ' + className : '')}>
      <MaterialUiRadioButton
        color="default"
        checked={isSelected}
        onChange={onClick}
        inputProps={{ id: uniqueId, name }}
        disabled={isDisabled}
        checkedIcon={
          <div className="radio-wrapper">
            <UntitledIcon name="circle.4" />
          </div>
        }
        icon={<div className="radio-wrapper"></div>}
        size={size}
      />
    </div>
  );
};

export default RadioButton;
